import { rankings } from '@/mocks/movies';
import SectionHeading from '@/pages/home/components/SectionHeading';

interface RankingSectionProps {
  onPickGenre: (genre: string) => void;
}

export default function RankingSection({ onPickGenre }: RankingSectionProps) {
  return (
    <section id="ranking" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="口碑榜单"
          title="555电影好看的电影推荐榜"
          desc="榜单综合评分、题材完成度与观众讨论热度排序，作为选片参考。评分只反映片库内的相对表现，建议结合个人口味使用。"
        />

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200">
          <div className="hidden grid-cols-[64px_1.6fr_1fr_1fr_120px] items-center gap-4 bg-background-100 px-6 py-3 text-xs font-medium text-foreground-500 md:grid">
            <span>排名</span>
            <span>片名与题材</span>
            <span>年份</span>
            <span>评分</span>
            <span>看点</span>
          </div>
          <div className="flex flex-col divide-y divide-background-200">
            {rankings.map((item) => {
              const genreMain = item.genre.split(' / ')[0];
              const top3 = item.rank <= 3;
              return (
                <div
                  key={item.rank}
                  className="grid grid-cols-1 gap-3 bg-background-50 px-4 py-4 transition-colors hover:bg-background-100 md:grid-cols-[64px_1.6fr_1fr_1fr_120px] md:items-center md:gap-4 md:px-6"
                >
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-sm font-black ${
                      top3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex flex-col gap-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <button
                      type="button"
                      onClick={() => onPickGenre(genreMain)}
                      className="w-fit cursor-pointer text-xs text-secondary-700 transition-colors hover:text-primary-700"
                    >
                      {item.genre}
                    </button>
                  </div>
                  <span className="text-sm text-foreground-600">{item.year}</span>
                  <div className="flex items-center gap-3">
                    <span className="w-10 text-sm font-bold text-accent-700">{item.rating}</span>
                    <span className="hidden h-1.5 w-24 overflow-hidden rounded-full bg-background-200 lg:block">
                      <span
                        className="block h-full rounded-full bg-primary-500"
                        style={{ width: `${Math.min(Number(item.rating) * 10, 100)}%` }}
                      />
                    </span>
                  </div>
                  <span className="text-xs leading-relaxed text-foreground-600">{item.note}</span>
                </div>
              );
            })}
          </div>
        </div>

        <p className="mt-4 text-xs text-foreground-500">
          榜单为站内整理的推荐参考，非官方评分，不同平台数据可能存在差异。
        </p>
      </div>
    </section>
  );
}